import { useController } from 'react-hook-form';
import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { ErrorMessage, useScreenQuery } from 'playup-web-core';

const ControlledSelectInput = ({
	name,
	placeholder,
	options = [],
	className,
}: {
	name: string;
	placeholder: string;
	options: { label: string; value: any }[];
	className?: string;
}) => {
	const {
		field,
		fieldState: { error },
	} = useController({
		name,
	});
	const { isSmall } = useScreenQuery();

	return (
		<SelectWrapper error={!!error} className={className}>
			<Select
				value={options.filter((c) => field.value === c.value)}
				onChange={(val) => {
					field.onChange(val?.value);
				}}
				ref={field.ref}
				placeholder={placeholder}
				options={options}
				styles={{
					container: (baseStyles, state) => ({
						...baseStyles,
						borderColor: error ? '#CF3935' : '#DDE1E3',
						borderWidth: 1,
						borderRadius: 4,
						fontSize: isSmall ? 14 : 18,
						zIndex: 5,
					}),
					control: (baseStyles, state) => ({
						...baseStyles,
						boxShadow: 'none',
						height: isSmall ? '40px' : '50px',
						borderColor: error ? '#CF3935' : '#DDE1E3',
						borderRadius: 4,
						paddingHorizontal: 11,
						backgroundColor: 'white',
						flex: 1,
						justifyContent: 'space-between',
						flexDirection: 'row',
						alignItems: 'center',
						cursor: 'pointer',
						color: 'black',
					}),
					singleValue: (baseStyles, state) => ({
						...baseStyles,
						color: 'black',
					}),
					placeholder: (baseStyles, state) => ({
						...baseStyles,
						paddingLeft: 2,
						color: '#a4a6a8',
					}),
					indicatorSeparator: (baseStyles, state) => ({
						visibility: 'hidden',
					}),
					option: (baseStyles, state) => ({
						...baseStyles,
						color: 'black',
					}),
				}}
			/>
			{error?.message && <ErrorMessage>{error?.message}</ErrorMessage>}
		</SelectWrapper>
	);
};
export default ControlledSelectInput;

const SelectWrapper = styled.div<{ error: boolean }>(({ error }) => ({
	display: 'flex',
	flexDirection: 'column',
}));
